import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMutation, useManualQuery } from "graphql-hooks";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  Avatar,
  Card,
  CardMedia,
  CardContent,
  Tooltip,
  Switch,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import FloatingMenu from "../components/FloatingMenu";
import sampleAvatar from "../assets/SearchResults/Avatars/Sarah_White.png";
import AlertPopup from "../components/AlertPopup";
import { isValidUUIDv4 } from "../hooks/uuid";

import { REPORT_BY_UUID, EDIT_REPORT_MUTATION } from "../graphQL/report_qry";

const StyledTooltip = ({ title, children }) => (
  <Tooltip
    title={title}
    placement="top"
    arrow
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -5],
          },
        },
      ],
    }}
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: "#666",
          color: "white",
          fontSize: "12px",
          fontWeight: "500",
          borderRadius: "4px",
          padding: "6px 8px",
          "& .MuiTooltip-arrow": {
            color: "#666",
          },
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

const UserLink = ({ username, userUuid }) => (
  <StyledTooltip title="View User's Page">
    <Link
      to={`/user/${userUuid}/profile`}
      style={{
        color: "#d32f2f",
        textDecoration: "none",
        fontSize: "14px",
        display: "inline-block",
        lineHeight: 1,
      }}
      onMouseEnter={(e) => {
        e.target.style.textDecoration = "underline";
      }}
      onMouseLeave={(e) => {
        e.target.style.textDecoration = "none";
      }}
    >
      {username}
    </Link>
  </StyledTooltip>
);

const adminURL = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";

export default function AdminReportEdit() {
  const { uuid } = useParams();
  const [note, setNote] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [alertPopup, setAlertPopup] = useState({
    open: false,    
  });
  const statusMap = {
    OPEN: "",
    UNDER_REVIEW: "Under Review",
    RESOLVED: "Resolved",
  };

  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [reportData, setReportData] = useState({});

  const [getReportData] = useManualQuery(REPORT_BY_UUID, {
    fetchPolicy: "network-only",
  });

  const [editReport] = useMutation(EDIT_REPORT_MUTATION, {
    awaitRefetchQueries: true,
  });
 
  let userUuid = localStorage.getItem("userUuid") ? localStorage.getItem("userUuid") : null;

  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);

  // Form validation errors
  const [errors, setErrors] = useState({
    note: "",
    status: ""
  });
  let role = localStorage.getItem("role") ? localStorage.getItem("role") : null;
  
  const dateFormatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }); 
  
  const dateFormat = (date) => {
      const dayDate = new Date(date);
      return dateFormatter.format(dayDate);
  };

  const loadReportInfo = async () => {    
    if (!uuid) {
      setIsInvalidURL(true);
      return;
    }
    if (isValidUUIDv4(uuid)){
        const {
          loading: loadingReportData,
          error: errorReportData,
          data: reportData,
        } = await getReportData({
          variables: {
            uuid: uuid,
          },
        });
        if (!loadingReportData && reportData && reportData.reportByUuid) {
          console.log(reportData.reportByUuid);
          if (role === "Admin"){
                setReportData({
                  ...reportData.reportByUuid,
                  dateReported: dateFormat(reportData.reportByUuid.dateReported),
                  contentType: reportData.reportByUuid.contentType.model.charAt(0).toUpperCase() + reportData.reportByUuid.contentType.model.slice(1)
                });
                setNote(reportData.reportByUuid.note);
                setStatus(statusMap[reportData.reportByUuid.status]);
          }
          else{
            setIsInvalidURL(true);      
          }
        }
        else
          setIsInvalidURL(true);
        if(errorReportData){
          console.log("errorReportData: ", errorReportData);
          setIsInvalidURL(true);
        }
    }  
    else
      setIsInvalidURL(true);    
  };

  useEffect(() => {
    console.log(uuid);
    (async () => loadReportInfo())();
  }, [uuid]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
  }, []);


const handleNoteChange = e => {
    setNote(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrors({ ...errors, note: "Note cannot be blank." });
    } else {
      setErrors({ ...errors, note: "" });
    }
  };

  const handleSave = async (publish) => {
    const newErrors = {};
    
    if (!note.trim()) {
          newErrors.note = "Note cannot be blank.";
    }
    console.log(status);
    if (!status.trim() || status == "Open") {
          newErrors.content =  "Status cannot be blank.";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

      const { data, error } =  await editReport({
          variables: {
            note: note,
            status: status,
            reportUuid: uuid,
          },
        });
        if (error) {
          console.log("Error", error, data);          
          // setTimeout("");
        } else {
          console.log("Success",data);
          navigate(adminURL + "/moderation-list");
        }
  };

  const handleCancel = () => {
    navigate(adminURL + "/moderation-list");
  };

 const handleClose = () => {
    setAlertPopup({ open: false, title: "" });
  };

  // Get username from localStorage
  const userName = localStorage.getItem("userName") || "jessica";

  return (
  <>
    {Object.keys(reportData).length > 0 ? (
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          py: 5,
          px: "100px",
          "@media (max-width: 1360px)": {
            px: "16px",
          },
        }}
      >
        <Helmet>
          <title>R3PLAY - Review Report</title>
          <meta
            name="description"
            content="Review reported data"
          />
        </Helmet>

        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 5,
            "@media (max-width: 856px)": {
              mb: 3,
            },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: "30px",
                fontWeight: "700",
                color: "#333",
                mb: 0.5,
                "@media (max-width: 856px)": {
                  fontSize: "24px",
                },
              }}
            >
              Report Detail
            </Typography>
            <Typography
              sx={{
                mt: 5,
                fontSize: "15px",
                color: "#666",
                "@media (max-width: 856px)": {
                  fontSize: "14px",
                },
              }}
            >
              <b>Date Reported:</b> {reportData.dateReported}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Reported by:</b> <UserLink username={reportData.reportedBy} userUuid={reportData.reportedByUserUuid} />
            </Typography>
            <Typography
              sx={{
                mt: 2,
                fontSize: "15px",
                color: "#666",
                "@media (max-width: 856px)": {
                  fontSize: "14px",
                },
              }}
            >
              <b>Page Reported:</b> {reportData.contentType}&nbsp;->&nbsp;{reportData.objectTitle}
            </Typography>
            <Typography
              sx={{
                mt: 2,
                fontSize: "15px",
                color: "#666",
                "@media (max-width: 856px)": {
                  fontSize: "14px",
                },
              }}
            >
              <b>Content Owner:</b> <UserLink username={reportData.objectOwner.username} userUuid={reportData.objectOwner.userUuid} />
            </Typography>
            <Typography
              sx={{
                mt: 2,
                fontSize: "15px",
                color: "#666",
                "@media (max-width: 856px)": {
                  fontSize: "14px",
                },
              }}
            >
              <b>Status:</b> {reportData.status}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "12px",
            p: 3,
            "@media (max-width: 856px)": {
              p: 2,
            },
            mt: 2,
          }}
        >
          {/* Form */}
          <Box>
            {/* Title/Summary Field */}
            <TextField
              fullWidth
              label="Notes"
              InputLabelProps={{ shrink: true }}
              placeholder="Notes"
              variant="outlined"
              required
              multiline
              rows={4}
              value={note}
              error={!!errors.note}
              helperText={errors.note}
              onChange={handleNoteChange}
              sx={{
                mb: 3,
              }}
            />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <RadioGroup
                    value={status}
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                    error={!!errors.status}
                    helperText={errors.status}
                    required
                >
                  <FormControlLabel
                    value="Under Review"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#666",
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{ fontSize: "14px", color: "#333" }}
                      >
                        Under Review
                      </Typography>
                    }
                    sx={{ margin: 0, flex: 1 }}
                  />
                  <FormControlLabel
                    value="Resolved"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#666",
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{ fontSize: "14px", color: "#333" }}
                      >
                        Resolved
                      </Typography>
                    }
                    sx={{ margin: 0, flex: 1 }}
                  />
                </RadioGroup>
              </Box>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  "@media (max-width: 856px)": {
                    gap: 1,
                  },
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleSave(true)}
                  disabled={!note || !status}
                  sx={{
                    height: "42px",
                    px: 3,
                    fontWeight: 500,
                    backgroundColor: "#EF5658",
                    "@media (max-width: 856px)": {
                      fontSize: "13px",
                      height: "30px",
                      px: 1,
                    },
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#000",
                    height: "42px",
                    px: 3,
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "#000",
                      borderColor: "#000",
                    },
                    "@media (max-width: 856px)": {
                      height: "30px",
                      fontSize: "13px",
                      px: 1,
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      
        <FloatingMenu left={floatMenuLeftMargin} />
      </Box>
  ) : (
      (isInvalidURL &&
        <Box sx={{ textAlign: "center", mb: 4, mt: 10 }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "30px",
              "@media (max-width: 856px)": {
                fontSize: "24px",
              },
              fontWeight: "700",
              color: "#333",
              mb: 1,
            }}
          >
            This URL is not valid.
          </Typography>
          <Button
          variant="contained"
          onClick={() => navigate(adminURL + "/dashboard")}
          sx={{
            height: "42px",
            px: 3,
            mt: 5,
            fontWeight: 500,
            backgroundColor: "#EF5658",
            "@media (max-width: 856px)": {
              fontSize: "13px",
              height: "30px",
              px: 1,
            },
          }}
        >
          OK
        </Button>
        </Box>
      )
  )}
  </>
  );
}
